<template>
  <div id="container">
    <div v-if="data" class="perfil">
      <user-image :img="imageUser"></user-image>
      <div class="container">
        <div class="main-body">
          <div class="row">
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <div
                    class="d-flex flex-column align-items-center text-center"
                  >
                    <img
                      :src="imageUser"
                      alt="Admin"
                      class="rounded-circle p-1 bg-primary imageUser"
                      width="110"
                    />
                    <div class="mt-3">
                      <h3>{{ data.nombre }}</h3>
                      <p class="text-secondary mb-1">
                        Estado: {{ data.estado }}
                      </p>
                      <p class="text-muted font-size-sm">{{ data.correo }}</p>
                      <p class="btn btn-primary">Puntaje: {{ this.puntaje }}</p>
                    </div>
                  </div>
                  <hr class="my-4" />
                  <ul class="list-group list-group-flush">
                    <li>
                      <router-link to="/sistema-de-coordenadas">
                        <h4>
                          <img
                            src="@/assets/img/icons3D/cubo_arrows.png"
                            alt="sistema coordenadas"
                          />
                          Sistemas de Coordenadas
                        </h4></router-link
                      >
                    </li>
                    <li>
                      <router-link to="/transformadas-3d">
                        <h4>
                          <img
                            src="@/assets/img/icons3D/transform_perspective_matte.png"
                            alt="tranformacion3d"
                          />Transformaciones 3D
                        </h4></router-link
                      >
                    </li>
                    <li>
                      <router-link to="/cuaterniones">
                        <h4>
                          <img
                            src="@/assets/img/icons3D/cubo_mas_Arrows.png"
                            alt="cuaterniones"
                          />Cuaterniones
                        </h4></router-link
                      >
                    </li>
                    <li>
                      <a href="https://voxcomp-mul.netlify.app/">
                        <h4>
                          <img
                            src="@/assets/img/icons3D/llenar_lapiz.png"
                            alt="curvas"
                          />Conectivismo
                        </h4></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="card">
                <div class="card-body">
                  <h2>Logros Obtenidos</h2>
                  <ul class="lista_logros">
                    <li v-for="image in images" :key="image.id" class="tooltip">
                      <!-- {{ logro }} -->
                      <img
                        v-if="logros.includes(image.name)"
                        :src="image.url"
                        :alt="image.name"
                      />
                      <span class="tooltiptext">{{ image.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <h3>Todos los logros</h3>
                      <ul class="lista_logros">
                        <li
                          v-for="image in images"
                          :key="image.id"
                          class="tooltip"
                        >
                          <!-- {{ logro }} -->
                          <img
                            class="logros_true"
                            v-if="logros.includes(image.name)"
                            :src="image.url"
                            :alt="image.name"
                          />
                          <img
                            v-else
                            :src="image.url"
                            :alt="image.name"
                            class="logros_false"
                          />
                          <span class="tooltiptext">{{ image.name }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <barra-herramientas></barra-herramientas> -->
  </div>
</template>
<script>
import * as Three from "three";
import UserImage from "../components/UserImage.vue";

import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import BarraHerramientas from "../components/BarraHerramientas.vue";

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export default {
  name: "FondoIntro",
  data() {
    return {
      url: "https://restserver-cg.onrender.com/api/auth/",
      cono: null,
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      gridHelper: null,
      rotar: false,
      tween1: null,
      tween2: null,
      transparente: null,
      modelo: null,
      loader: null,
      group: null,
      torusKnot: null,
      line: null,
      imageUser: null,
      logros: null,
      puntaje: null,
      data: null,
      images: [
        {
          id: 1,
          url: require("@/assets/img/icons3D/bang_perspective_matte.png"),
          name: "ActividadTransformadas3d",
        },
        {
          id: 2,
          url: require("@/assets/img/icons3D/bombilla.png"),
          name: "DemostracionTransformadas3d",
        },
        {
          id: 3,
          url: require("@/assets/img/icons3D/column.png"),
          name: "sistemaCoordenadas",
        },
        {
          id: 4,
          url: require("@/assets/img/icons3D/construct.png"),
          name: "DemostracionSistemaCoordenadas",
        },
        {
          id: 5,
          url: require("@/assets/img/icons3D/cubo_arrows.png"),
          name: "CuestionarioSistemaCoordenadas",
        },
        {
          id: 6,
          url: require("@/assets/img/icons3D/cubo_mas_Arrows.png"),
          name: "CuestionarioCuaterniones",
        },
        {
          id: 7,
          url: require("@/assets/img/icons3D/exam.png"),
          name: "CuestionarioTransformadas3d",
        },
        {
          id: 8,
          url: require("@/assets/img/icons3D/Exchange_perspective_matte.png"),
          name: "DemostracionCuaterniones",
        },

        {
          id: 12,
          url: require("@/assets/img/icons3D/montañas.png"),
          name: "ActividadSistemaCoordenadas",
        },
        {
          id: 13,
          url: require("@/assets/img/icons3D/perspective_matte.png"),
          name: "TeoriaCuaterniones",
        },
        {
          id: 14,
          url: require("@/assets/img/icons3D/premio.png"),
          name: "ActividadCuaterniones",
        },
        {
          id: 15,
          url: require("@/assets/img/icons3D/transform_perspective_matte.png"),
          name: "TeoriaTransformadas3d",
        },
      ],
    };
  },
  components: { UserImage },
  methods: {
    salir() {
      this.$gAuth.signOut();
      localStorage.removeItem("token");
      this.$router.push("/");
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          this.data = response.data;
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
          this.puntaje = response.data.puntaje;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = 16;
      this.scene = new Three.Scene();
      this.scene.rotation.x = Math.PI / 2;
      this.scene.rotation.y = -Math.PI;
      const spotLight = new Three.SpotLight(0xffffff, 0.7);
      spotLight.position.set(-10, 2, 10);

      const targetObject = new Three.Object3D();
      targetObject.position.set(-15, 5, 1);
      this.scene.add(targetObject);

      spotLight.target = targetObject;

      this.scene.add(spotLight.target);
      this.scene.add(spotLight);

      let geometry = new Three.BoxGeometry(1, 1, 1);
      let material = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      let material2 = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      // let material3 = new Three.MeshNormalMaterial({
      //   // color: 0x0000ff,
      //   transparent: true,
      //   opacity: 1.0,
      // });
      this.mesh = new Three.Mesh(geometry, material);
      this.mesh.position.y = 1.5;
      this.mesh.position.x = -14.3;
      this.mesh.position.z = 6.7;

      this.scene.add(this.mesh);

      const torusKnotGeo = new Three.TorusKnotGeometry(1, 0.3, 100, 16);
      // const material = new Three.MeshBasicMaterial({ color: 0xffff00 });
      this.torusKnot = new Three.Mesh(torusKnotGeo, material2);
      this.torusKnot.position.y = 4.5;
      this.torusKnot.position.x = -8.3;
      this.torusKnot.position.z = -5.7;
      this.scene.add(this.torusKnot);
      const light = new Three.PointLight();
      light.position.set(200, 100, 150);
      this.scene.add(light);

      this.scene.add(new Three.PointLightHelper(light, 15));
      this.loader = new GLTFLoader();
      this.loader.load("/models/LeePerrySmith.glb", (glb) => {
        this.modelo = glb.scene.children[0];
        console.log(this.modelo);

        // this.modelo.geometry.computeTangents(); // generates bad data due to degenerate UVs

        this.group = new Three.Group();
        this.group.scale.multiplyScalar(0.8);
        this.scene.add(this.group);

        // To make sure that the matrixWorld is up to date for the boxhelpers
        this.group.updateMatrixWorld(true);

        const materialWireframe = new Three.LineBasicMaterial({
          color: 0x0000ff,
          linewidth: 1,
          opacity: 0.45,
          linecap: "round", //ignored by WebGLRenderer
          linejoin: "round", //ignored by WebGLRenderer
        });
        // this.group.add(this.modelo);
        this.group.position.y = 1.5;
        this.group.position.x = 14.3;
        this.group.position.z = 2.7;
        const wireframe = new Three.WireframeGeometry(this.modelo.geometry);
        this.line = new Three.LineSegments(wireframe, materialWireframe);
        this.line.material.depthTest = true;
        // this.line.material.opacity = 0.45;
        this.line.material.transparent = true;
        // this.line.position.x = 4;
        this.group.add(this.line);
        // const boxHelper = new Three.BoxHelper(this.modelo);
        // this.group.add(boxHelper);
      }),
        (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        (error) => {
          console.error(error);
        };

      const GeoCono = new Three.ConeGeometry(0.5, 1, 32);
      const geoCil = new Three.CylinderGeometry(0.5, 0.5, 1, 32);

      const cylinder2 = new Three.Mesh(geoCil, material);
      const cubo = new Three.Mesh(geometry, material);
      this.cono = new Three.Mesh(GeoCono, material);

      cubo.position.y = 4.5;
      cubo.position.x = 8.5;
      cubo.position.z = -5.7;

      cylinder2.position.y = 3;
      cylinder2.position.x = 9.3;
      cylinder2.position.z = -3.7;

      this.cono.position.y = 3.5;
      this.cono.position.x = 7.3;
      this.cono.position.z = -4;

      cubo.scale.set(1.5, 1.5, 1.5);
      this.cono.scale.set(1.5, 1.5, 1.5);
      cylinder2.scale.set(1.5, 1.5, 1.5);

      this.scene.add(cubo);
      this.scene.add(this.cono);
      this.scene.add(cylinder2);

      const size = 50;
      const divisions = 50;

      this.gridHelper = new Three.GridHelper(size, divisions);
      //   this.gridHel   per.rotation.x = Math.PI / 2;
      this.scene.add(this.gridHelper);

      const moverRotaciones1 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones2.start();
        });
      const moverRotaciones2 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones1.start();
        });
      moverRotaciones2.start();

      const moverRotacionesCubo1 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI / 2, x: -Math.PI }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo2.start();
        });
      const moverRotacionesCubo2 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI, x: Math.PI / 2 }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo1.start();
        });
      moverRotacionesCubo1.start();

      const moverRotacionesCyli1 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI / 2, z: -Math.PI }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli2.start();
        });
      const moverRotacionesCyli2 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI, z: Math.PI / 2 }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli1.start();
        });
      moverRotacionesCyli1.start();

      this.tween1 = new TWEEN.Tween(this.scene.rotation)
        .to({ x: 0.2, y: 0 }, 6000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {});

      this.tween2 = new TWEEN.Tween(this.scene.position)
        .to({ z: -12 }, 6000) //6000
        .easing(TWEEN.Easing.Cubic.InOut);

      const moverTorus1 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1.5, y: 1.5, z: 1.5 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus2.start();
        });
      const moverTorus2 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1, y: 1, z: 1 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus3.start();
        });
      const moverTorus3 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 7.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus4.start();
        });
      const moverTorus4 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus5.start();
        });
      const moverTorus5 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI / 2, y: Math.PI / 2, z: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus6.start();
        });
      const moverTorus6 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI, y: Math.PI, z: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus1.start();
        });
      moverTorus1.start();

      const moverCubo1 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 + 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo2.start();
        });
      const moverCubo2 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo3.start();
        });
      const moverCubo3 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo4.start();
        });
      const moverCubo4 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 1.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo1.start();
        });
      moverCubo1.start();
      this.transparente = new Three.MeshLambertMaterial({
        color: 0x0000ff,
        transparent: true,
        opacity: 0.0,
      });

      let maxX = 2;
      let axisXLength = maxX * 2;
      const axisXHeadLength = axisXLength * 0.25;
      const axisXHeadWidth = axisXHeadLength * 1;
      const directionX = new Three.Vector3(1, 0, 0);
      const startX = new Three.Vector3(-maxX, 0, 0);
      const colorX = 0xff0000;
      const axisX = new Three.ArrowHelper(
        directionX,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      axisX.position.x = -15;
      axisX.position.y = 1;
      axisX.position.z = 6;

      const geometryX = new Three.CylinderGeometry(0.15, 0.15, 5, 32);
      const materialX = new Three.MeshPhongMaterial({ color: colorX });
      const cylinder = new Three.Mesh(geometryX, materialX);
      cylinder.rotation.z = Math.PI / 2;
      cylinder.position.x = -12.5;
      cylinder.position.y = 1;
      cylinder.position.z = 6;
      this.scene.add(cylinder);

      this.scene.add(axisX);

      let axisYLength = maxX * 2;
      const axisYHeadLength = axisYLength * 0.25;
      const axisYHeadWidth = axisYHeadLength;
      const directionY = new Three.Vector3(0, 1, 0);
      const startY = new Three.Vector3(0, maxX, 0);
      const colorY = 0x00ff00;
      const axisY = new Three.ArrowHelper(
        directionY,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      axisY.position.x = -15;
      axisY.position.y = 1;
      axisY.position.z = 6;

      const materialY = new Three.MeshPhongMaterial({ color: colorY });
      const cylinderY = new Three.Mesh(geometryX, materialY);
      cylinderY.rotation.y = Math.PI / 2;
      cylinderY.position.x = -15;
      cylinderY.position.y = 3.5;
      cylinderY.position.z = 6;
      this.scene.add(cylinderY);
      this.scene.add(axisY);

      let axisZLength = maxX * 2;
      const axisZHeadLength = axisZLength * 0.25;
      const axisZHeadWidth = axisZHeadLength;
      const directionZ = new Three.Vector3(0, 0, 1);
      const startZ = new Three.Vector3(0, 0, maxX);
      const colorZ = 0x0000ff;
      const axisZ = new Three.ArrowHelper(
        directionZ,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );
      axisZ.position.x = -15;
      axisZ.position.y = 1;
      axisZ.position.z = 6;

      const materialZ = new Three.MeshPhongMaterial({ color: colorZ });
      const cylinderZ = new Three.Mesh(geometryX, materialZ);
      cylinderZ.rotation.x = Math.PI / 2;
      cylinderZ.position.x = -15;
      cylinderZ.position.y = 1;
      cylinderZ.position.z = 3.5 + 5;
      this.scene.add(cylinderZ);

      this.scene.add(axisZ);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      if (this.$router.history.current.path == "/perfil") {
        window.addEventListener("resize", this.onWindowResize);
        if (this.modelo) {
          this.group.rotation.y += 0.009;
        }
        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.renderer.render(this.scene, this.camera);
      }
    },
  },
  mounted() {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") != "undefined"
    ) {
      console.log("ya esta logueado");
      this.profile();
    } else {
      this.$router.push("/ingreso-home");
    }
    this.init();
    this.animate();
  },
};
</script>
<style scoped>
#container {
  width: 100vw;
  height: 100vh;
}
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  /* content: ""; */
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.perfil {
  position: absolute;
  width: 95vw;
  height: 95vh;
  margin: auto;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: 20px;
  color: #1a202c;
  text-align: left;
  /* background-color: #e2e8f0; */
}
.main-body {
  padding: 15px;
}
.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  margin: 1rem 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.gutters-sm {
  margin-right: -8px;
  margin-left: -8px;
}

.gutters-sm > .col,
.gutters-sm > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}
.h-100 {
  height: 100% !important;
}
.shadow-none {
  box-shadow: none !important;
}
h4 {
  display: inline-block;
  margin-bottom: 1rem;
}
h4 img {
  display: inline-block;
  width: 3rem;
  margin-right: 1rem;
}
.imageUser {
  border-radius: 50%;
  width: fit-content;
  margin: auto;
}
.lista_logros {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.lista_logros li img {
  width: 5rem;
  margin: 0.5rem;
}
.logros_false {
  opacity: 0.2;
}
.logros_false:hover {
  opacity: 1;
}
h3,
h2,
h4 {
  font-weight: bold;
}
h3,
h2 {
  font-size: 1.2rem;
}
</style>
